<template>
  <v-layout wrap>
    <v-flex xs12>
      <AppForm label="抽出条件" />
    </v-flex>
    <v-flex xs12 offset-xs1>
      <AppForm label="対象年代" />
    </v-flex>
    <v-flex xs12 offset-xs1 pl-4>
      <div
        v-for="targetAge in targetAges"
        :key="targetAge.code"
        class="horizontal-list"
      >
        <input
          v-model="targetAge.value"
          type="checkbox"
          class="checkbox-input"
        />
        <label class="checkbox-text">{{ targetAge.name }}</label>
      </div>
    </v-flex>
    <v-flex xs12 mt-3>
      <AppForm label="対象地域" />
    </v-flex>
    <v-flex xs12 offset-xs1>
      <AppAreaSelectorWithSplitGroupCheckbox :form="form" />
    </v-flex>
    <v-flex xs12>
      <AppForm label="備考" />
    </v-flex>
    <v-flex xs10 mt-1 offset-xs1>
      <v-textarea v-model="menuSetting.memo" outline />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      targetAges: [
        { name: '0 - 4 歳', value: false, code: 1 },
        { name: '5 - 9 歳', value: false, code: 2 },
        { name: '10 - 14 歳', value: false, code: 3 },
        { name: '15 - 19 歳', value: false, code: 4 },
      ],
    }
  },
  computed: {
    errorMessage() {
      const errorMessages = []
      if (this.menuSetting.targetAges.length === 0)
        errorMessages.push('対象年代を指定してください')
      if (
        this.menuSetting.area.isEmpty(
          this.menuSetting.administrativeDistrictType,
        )
      ) {
        errorMessages.push('対象地域を指定してください')
      }
      return errorMessages.length === 0 ? '' : errorMessages
    },
    menuSetting() {
      return this.form.campaign.menuSetting.orderDescription
    },
  },
  watch: {
    targetAges: {
      handler(value) {
        value = value
          .filter(targetAge => targetAge.value === true)
          .map(targetAge => targetAge.code)
        this.menuSetting.targetAges = value
      },
      deep: true,
    },
  },
  created() {
    this.targetAges.map(targetAge => {
      if (this.menuSetting.targetAges.indexOf(targetAge.code) > -1) {
        targetAge.value = true
      }
    })
  },
}
</script>

<style scoped>
.horizontal-list {
  display: inline-block;
  margin-left: 50px;
  margin-top: 15px;
}

.checkbox-text {
  margin-left: 10px;
  font-size: 20px;
}

.checkbox-input {
  width: 20px;
  height: 20px;
}

.v-textarea >>> textarea {
  margin-top: 0;
}
</style>
